module.exports = __webpack_public_path__ + "static/img/1.69ff448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.png
// module id = 223
// module chunks = 1